import { useCallback, useEffect } from 'react'
import { PosthogParamEventName } from '@app/constants'
import { useTrackUserMagicLinkMutation } from '@app/graphql'
import { posthogGetDistinctId } from '@app/helpers/misc'

export const usePosthogMagicLinkTracking = (auto=true) => {
  const [ trackUserMagicLink ] = useTrackUserMagicLinkMutation()
  const handlePosthogMagicLink = useCallback(async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const phEventName = urlParams.get(PosthogParamEventName)
    const email = urlParams.get('email')

    if (phEventName) {
      try {
        urlParams.delete(PosthogParamEventName)
        const newUrl = `${window.location.pathname}?${urlParams.toString()}`
        window.history.replaceState({}, '', newUrl)

        await trackUserMagicLink({
          variables: {
            email,
            sessionId: posthogGetDistinctId()
          },
        })
      } catch (error) {
        console.error('Error during auth callback:', error)
      }
    }
  }, [trackUserMagicLink])

  useEffect(() => {
    if(auto) {
      void handlePosthogMagicLink()
    }
  }, [])
  return { handlePosthogMagicLink }
}